

























































































































































































import Vue from 'vue';
import { mapState } from 'vuex';
import TextBoxDatePicker from '@/components/TextBoxDatePicker.vue';
import ProductMappingSelect from '@/components/ProductMappingSelect.vue';
import {
  Component, Prop, Watch, Inject,
} from 'vue-property-decorator';
import {
  EngagementReward, EngagementRewardVersion, EngagementRewardTypeNames, DistributionCadenceNames, SegmentationNames, PeriodTypeNames, EngagementDurationTypeNames, EngagementRewardGapResponse, EngagementRewardResource,
} from '@/api/engagementrewards';
import { DateTool } from '@/util';


@Component({
  computed: mapState(['fiId']),
  components: {
    TextBoxDatePicker, ProductMappingSelect,
  },
})
export default class EngagementRewardEditor extends Vue {
  fiId!: string;

  @Prop()
  value!: EngagementRewardVersion;

  @Prop()
  reward!: EngagementReward;

  selectedTab: number = 0;

  @Prop({ default: true })
  isEditable!: boolean;

  @Prop({ default: true })
  editingExisting!: boolean;

  @Inject('EngagementRewardResource')
  engagementRewardResource!: EngagementRewardResource;

  valid:boolean = true;

  originalStartDate: string | null = null;

  versionGap: EngagementRewardGapResponse | null = null;

  // Make visible to template
  EngagementRewardTypeNames:Map<string, string> = EngagementRewardTypeNames;

  // Make visible to template
  DistributionCadenceNames:Map<string, string> = DistributionCadenceNames;

  // Make visible to template
  SegmentationNames:Map<string, string> = SegmentationNames;

  // Make visible to template
  PeriodTypeNames:Map<string, string> = PeriodTypeNames;

  // Make visible to template
  EngagementDurationTypeNames:Map<string, string> = EngagementDurationTypeNames;

  requiredRule:Array<any> = [(value: any) => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [(value: number) => {
    if (!value) {
      return 'Required';
    } if (value <= 0) {
      return 'Must be positive';
    }
    return true;
  }];

  validateUniqueDesignStartDate(value: any) : boolean | string {
    if (value !== null && value.length !== 0 && this.originalStartDate) {
      const valueDate:Date = new Date(value);
      const originalDate:Date = DateTool.parseDate(this.originalStartDate);

      if (valueDate.getTime() !== originalDate.getTime() || (!this.editingExisting && this.isEditable && this.reward.id)) {
        for (let i = 0; i < this.reward.versions.length; i++) {
          if (DateTool.parseDate(this.reward.versions[i].designStartDate).getTime() === valueDate.getTime()) {
            return 'A version of this reward already exists with the given engagement reward version start date.  Please pick a different date.';
          }
        }
      }
    }
    return true;
  }

  validateDesignStartOnOrBeforeDurationStart(value: any) : boolean | string {
    if (value && value.length !== 0 && this.value.startDate && this.value.startDate.length !== 0 && this.value.durationType !== 'ACTIVE_ALWAYS') {
      const designStart:Date = new Date(value);
      const durationStart:Date = DateTool.parseDate(this.value.startDate);

      if (designStart.getTime() > durationStart.getTime()) {
        return 'This engagement reward version start date is after the specified Duration start date.';
      }
    }

    return true;
  }

  validateDurationStartOnOrAfterDesignStart(value: any) : boolean | string {
    if (value && value.length !== 0 && this.value.designStartDate && this.value.designStartDate.length !== 0 && this.value.durationType !== 'ACTIVE_ALWAYS') {
      const durationStart:Date = new Date(value);
      const designStart:Date = DateTool.parseDate(this.value.designStartDate);

      if (designStart.getTime() > durationStart.getTime()) {
        return 'The specified engagement reward duration start is before the engagement reward version start date.  Choose another date on or after the version start.';
      }
    }

    return true;
  }

  validateIsOnOrBeforeEndDate(value:any) : boolean | string {
    if (!this.value.endDate || this.value.endDate.length === 0) {
      return true;
    }

    if (value && value.length > 0) {
      const startDateTime:Date = new Date(value.toString());
      const endDateTime:Date = new Date(this.value.endDate.toString());
      const endDate = new Date(endDateTime.getUTCFullYear(), endDateTime.getUTCMonth(), endDateTime.getUTCDate());
      const startDate = new Date(startDateTime.getUTCFullYear(), startDateTime.getUTCMonth(), startDateTime.getUTCDate());
      if (startDate.getTime() > endDate.getTime()) {
        return 'Start date must be on or before the configured end date.';
      }
    }
    return true;
  }

  validateIsOnOrAfterStartDate(value:any) : boolean | string {
    if (!this.value.startDate || this.value.startDate.length === 0) {
      return true;
    }

    if (value && value.length > 0) {
      const endDateTime:Date = new Date(value.toString());
      const startDateTime:Date = new Date(this.value.startDate.toString());
      const endDate = new Date(endDateTime.getUTCFullYear(), endDateTime.getUTCMonth(), endDateTime.getUTCDate());
      const startDate = new Date(startDateTime.getUTCFullYear(), startDateTime.getUTCMonth(), startDateTime.getUTCDate());

      if (startDate.getTime() > endDate.getTime()) {
        return 'End date must be on or after the configured start date.';
      }
    }
    return true;
  }

  reloadVersionGapInfo() {
    if (!this.value.id || !this.value.designStartDate) {
      return;
    }

    this.engagementRewardResource.getVersionGap(this.fiId, this.value.id!, this.value.designStartDate)
      .then((gapResponse:EngagementRewardGapResponse) => {
        this.versionGap = gapResponse;
      }).catch((error:any) => {
        console.error(`Error looking up version gap ${error}`);
      });
  }

  @Watch('value.durationType')
  @Watch('value.designStartDate')
  @Watch('value.durationType')
  @Watch('value.endDate')
  @Watch('value.startDate')
  async watchDateInputs() {
    await this.$nextTick();
    const aForm : any = (this.$refs.form as any);
    if (aForm) {
      aForm.validate();
    }
  }

  @Watch('value.designStartDate')
  async watchOnlyDesignStartDate() {
    this.reloadVersionGapInfo();
  }

  mounted() {
    this.onWorkingVersionValueChange();
    this.reloadVersionGapInfo();
  }

  @Watch('value', { deep: true })
  onWorkingProductContentChange() {
    this.$emit('input', this.value);
  }

  @Watch('value', { deep: false })
  onWorkingVersionValueChange() {
    this.originalStartDate = this.value.designStartDate;
  }

  @Watch('valid')
  onValidChange() {
    this.$emit('editFormValid', this.valid);
  }
}
